import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useAuth } from "src/context";
import FormLayout from "src/layouts/FormLayout";
import { Row, Col } from "src/components/layout";
import { Button, Input } from "@porchpass/ui";
import { dealerStorage } from "src/utils";

export default () => {
  const { dealerName } = useParams();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [smsCode, setSmsCode] = useState("");
  const authObj = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authObj.user && authObj.user.accessToken) {
      navigate(`/${dealerName}/register`);
    }
  }, [authObj.user]);

  const showExtraOptions = searchParams.get("show-all") === "true";
  return (
    <FormLayout
      title="Dummy Auth Page"
      subtitle="Not real, don't judge me"
      headerTitle="Firebase Auth Testing"
    >
      <Row>
        <Col>
          <Input
            label="email"
            name="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <Input
            label="password"
            name="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          {showExtraOptions && (
            <>
              <Input
                label="phone_number"
                name="phone_number"
                value={phone}
                onChange={(event) => setPhone(event.target.value)}
              />
              <Input
                label="sms_code"
                name="sms_code"
                value={smsCode}
                onChange={(event) => setSmsCode(event.target.value)}
              />
            </>
          )}
          <Button
            type="button"
            variant="secondary"
            className="w-full"
            onClick={() => {
              void authObj.createUser(email, password);
            }}
          >
            Create with email/password!
          </Button>
          {showExtraOptions && (
            <>
              <Button
                type="button"
                variant="secondary"
                className="w-full"
                onClick={() =>
                  void authObj
                    .createMagicLink(email)
                    .then(() =>
                      dealerStorage.setItem("email-for-sign-in", email),
                    )
                }
              >
                Create via Magic Link!
              </Button>
              <Button
                type="button"
                variant="secondary"
                className="w-full"
                onClick={() => authObj.sendSMSCode(phone)}
              >
                Create via Phone Code!
              </Button>
              <Button
                type="button"
                variant="secondary"
                className="w-full"
                onClick={() => authObj.signInWithSMSCode(smsCode)}
              >
                Sign in via SMS Code!
              </Button>
            </>
          )}
          <div id="recaptcha-container"></div>
        </Col>
      </Row>
      <Row></Row>
    </FormLayout>
  );
};
